import { render } from "./pickup-detail-header.vue?vue&type=template&id=ff5a90b0&scoped=true&ts=true"
import script from "./pickup-detail-header.vue?vue&type=script&lang=ts"
export * from "./pickup-detail-header.vue?vue&type=script&lang=ts"

import "./pickup-detail-header.vue?vue&type=style&index=0&id=ff5a90b0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff5a90b0"]])

export default __exports__